import { PaletteColor } from '@mui/material'

declare module '@mui/material/styles' {
	interface Palette {
		gameViewMaster: Palette['primary']
	}

	interface PaletteOptions {
		gameViewMaster?: PaletteOptions['primary']
	}
}

declare module '@mui/material/Alert' {
	interface AlertPropsColorOverrides {
		gameViewMaster: true
	}
}

export const gameViewMasterColor = {
	main: '#B42A17',
	light: '#EB6E5C8C',
} as PaletteColor
